module.exports = __webpack_public_path__ + "media/img/institutions/student-avatar-bg-1-295a35ae2eb29485a9be8d1c6f9e06e3.svg";